import "../style/PieChartSkeleton.css";

const PieChartSkeleton = () => {
    return (
        <div className="pcs-wrapper">
            <div className="pcs-card">
                <div className="pcs-title pcs-skeleton"></div>

                {/* Pie Chart Area */}
                <div className="pcs-chart-wrapper">
                    <div className="pcs-pie pcs-skeleton"></div>
                </div>

                {/* Legend */}
                <div className="pcs-legend">
                    {[1, 2, 3, 4].map((_, i) => (
                        <div key={i} className="pcs-legend-item">
                            <div className="pcs-legend-color pcs-skeleton"></div>
                            <div className="pcs-legend-text pcs-skeleton"></div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default PieChartSkeleton;
